/* Patéa SEM: consent-gated public storefront events. No customer or order fields. */
(()=>{
 'use strict';
 if(window.__pateaSemV1 || window.Shopify?.designMode)return;
 const tag=document.currentScript;
 const state=window.__pateaSemV1={version:'1.0.0',status:'WAITING_PRIVACY',pageViews:0,productViews:0,cartAdds:0};
 let privacy,permitted=false,generation=0,loaded,configured=false,queue=Promise.resolve(),pageClaimed=false,productClaimed=false;
 const seenAdds=new WeakSet();
 function publicLocation(){
  try{
   const u=new URL(window.location.href);
   if(u.origin!=='https://pateabotanica.com'||u.username||u.password||u.hash)return false;
   if(!/^\/(?:cs|en)?\/?$/.test(u.pathname)&&!/^\/(?:cs\/|en\/)?(?:products\/[a-z0-9-]+|collections(?:\/[a-z0-9-]+)?(?:\/products\/[a-z0-9-]+)?|pages\/[a-z0-9-]+|blogs\/[a-z0-9-]+(?:\/[a-z0-9-]+)?|cart)\/?$/.test(u.pathname))return false;
   if(u.search.length>1400)return false;
   const seen=new Set();
   for(const [key,value] of u.searchParams){
    if(seen.has(key))return false;seen.add(key);
    if(key==='variant'){if(!/^[1-9][0-9]{0,19}$/.test(value))return false;}
    else if(key==='page'){if(!/^[1-9][0-9]{0,3}$/.test(value))return false;}
    else if(key==='sort_by'){if(!['manual','best-selling','title-ascending','title-descending','price-ascending','price-descending','created-ascending','created-descending'].includes(value))return false;}
    else if(['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id'].includes(key)){if(!/^[A-Za-z0-9_.~-]{1,120}$/.test(value))return false;}
    else if(key==='hgtid'){if(!/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(value))return false;}
    else if(['gclid','dclid','gbraid','wbraid','fbclid','msclkid','sznclid','sznaiid'].includes(key)){if(!/^[A-Za-z0-9_.~-]{1,256}$/.test(value))return false;}
    else return false;
   }
   return true;
  }catch{return false;}
 }
 function consent(){try{return {analytics:privacy.analyticsProcessingAllowed()===true,marketing:privacy.marketingAllowed()===true,sale:privacy.saleOfDataAllowed()===true,preferences:privacy.preferencesProcessingAllowed()===true};}catch{return {}}}
 function allowed(){const p=consent();return p.analytics&&p.marketing&&p.sale&&publicLocation();}
 function mode(){const p=consent(),advertising=p.marketing&&p.sale;return {consent_mode:{ad_storage:advertising?'granted':'denied',ad_user_data:advertising?'granted':'denied',ad_personalization:advertising?'granted':'denied',analytics_storage:p.analytics?'granted':'denied',functionality_storage:p.preferences?'granted':'denied'}};}
 function valid(gen){return permitted&&gen===generation&&allowed();}
 function sdk(){
  if(loaded)return loaded;
  loaded=new Promise((resolve,reject)=>{
   if(typeof window.SEM==='function'||document.querySelector('script[data-patea-sem-sdk]')){reject(Error('EXISTING_SEM'));return;}
   const s=document.createElement('script');s.src='https://l.seznam.cz/static/js/sem.js';s.async=true;
   s.setAttribute?.('data-patea-sem-sdk','');
   const t=setTimeout(()=>reject(Error('SDK_TIMEOUT')),15000);
   s.onload=()=>{clearTimeout(t);typeof window.SEM==='function'?resolve():reject(Error('SDK_UNAVAILABLE'));};
   s.onerror=()=>{clearTimeout(t);reject(Error('SDK_LOAD_FAILED'));};document.head.appendChild(s);
  });
  return loaded;
 }
 async function prepare(gen){
  if(!valid(gen))return false;
  await sdk();if(!valid(gen))return false;
  if(!configured){await window.SEM('config',{sem_id:'hmlju1eb0de2axas06ihjzk9'});configured=true;}
  if(!valid(gen))return false;
  await window.SEM('updateConsent',mode());return valid(gen);
 }
 function enqueue(task){queue=queue.then(task).catch(()=>{state.status='MEASUREMENT_UNAVAILABLE';});}
 function contents(id,quantity){
  const text=typeof id==='number'&&Number.isSafeInteger(id)?String(id):typeof id==='string'?id:'';
  if(!/^[1-9][0-9]{0,19}$/.test(text)||(quantity!==undefined&&(!Number.isSafeInteger(quantity)||quantity<1||quantity>1000)))return null;
  return {content_type:'product',contents:[{id:'PB_'+text,...(quantity===undefined?{}:{quantity})}]};
 }
 function sync(){
  const next=Boolean(allowed());if(next!==permitted){permitted=next;generation++;}
  const gen=generation;
  if(!next){state.status='CONSENT_OR_URL_BLOCKED';if(configured)enqueue(async()=>{if(!permitted)await window.SEM('updateConsent',mode());});return;}
  enqueue(async()=>{
   if(!await prepare(gen))return;
   state.status='READY';
   if(!pageClaimed){pageClaimed=true;state.pageViews++;await window.SEM('track','PageView');}
   if(!valid(gen))return;
   if(tag?.dataset.pageType==='product'&&!productClaimed){const data=contents(tag.dataset.variantId,1);if(data){productClaimed=true;state.productViews++;await window.SEM('track','ViewContent',data);}}
  });
 }
 document.addEventListener('visitorConsentCollected',sync);
 document.addEventListener('product-ajax:added',event=>{
  if(!allowed()||!permitted||seenAdds.has(event))return;seenAdds.add(event);
  const product=event.detail?.product;const items=Array.isArray(product?.items)?product.items:[product];
  // Ajax response quantity is the resulting cart total, not the increment.
  // Quantity is optional for AddToCart; omit it rather than report a false count.
  const rows=items.map(x=>contents(x?.id));if(!rows.length||rows.length>50||rows.some(x=>!x))return;
  const data={content_type:'product',contents:rows.flatMap(x=>x.contents)},gen=generation;
  enqueue(async()=>{if(!await prepare(gen))return;state.cartAdds++;await window.SEM('track','AddToCart',data);});
 });
 if(!publicLocation()){state.status='PRIVATE_URL_BLOCKED';return;}
 try{
  const s=window.Shopify;if(typeof s?.loadFeatures!=='function'){state.status='PRIVACY_UNAVAILABLE';return;}
  s.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(error||!s.customerPrivacy){state.status='PRIVACY_UNAVAILABLE';return;}privacy=s.customerPrivacy;sync();});
 }catch{state.status='PRIVACY_UNAVAILABLE';}
})();
